import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "attention_white",
  "use": "attention_white-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"attention_white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.67 11.775L10.774.857C10.386.247 9.723 0 9 0c-.723 0-1.386.248-1.775.857L.33 11.775a2.106 2.106 0 0 0 1.775 3.24h13.788a2.105 2.105 0 0 0 1.775-3.24zM9 13.195A1.148 1.148 0 1 1 9 10.9a1.148 1.148 0 0 1 0 2.296zM8.86 9.89a1.026 1.026 0 0 0 1.166-.864l.137-4.46a1.151 1.151 0 1 0-2.302 0L8 9.04c.07.429.409.783.861.85z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol